import { defineComponent as _defineComponent } from 'vue'
import { computed, del, onMounted, ref, Ref, unref } from 'vue';
import { VatType } from '@/Enums';
import VatDetailEdit from '@/components/settings/children/VatDetailEdit.vue';
import { editSettingsPolicy } from "@/authorization/policies";
import { hasAccessRights } from "@/authorization/AuthorizationService";
import { createVatDetail, deleteVatDetail, fetchVatDetails } from './scripts/VatDetails/vatDetailsApiRequests';
import { VatDetail } from '@/scripts/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'VatSettings',
  emits: [
  'onFetchError'
],
  setup(__props, { emit: emits }) {


const regularVatTypes = computed(() => unref(vatDetails).filter(detail => detail.vatType === VatType.Regular))
const reducedVatTypes = computed(() => unref(vatDetails).filter(detail => detail.vatType === VatType.Reduced))

const reducedVatListRef = ref<InstanceType<typeof VatDetailEdit>>();
const regularVatListRef = ref<InstanceType<typeof VatDetailEdit>>();

const reducedVatListValid = ref(true);
const regularVatListValid = ref(true);

const vatDetails : Ref<VatDetail[]> = ref([]);



const onHandleFetchError = ({error}: {
  error: any
}) => {
  emits('onFetchError', {error})
};

const loadVatDetails = async () => {

  const { error, response } = await fetchVatDetails();

  return error ? onHandleFetchError({error}) : (vatDetails.value = response!);
}

const removeVatDetail = async (vatDetail: VatDetail) => {

  const { error } = await deleteVatDetail(vatDetail.id);
  if(error){
    onHandleFetchError({error});
    return;
  }

  const itemIndex = unref(vatDetails).indexOf(vatDetail);
  if (itemIndex === -1) return;
  unref(vatDetails).splice(itemIndex, 1);
}

const addVatDetail = async (vatDetail: VatDetail) => {

  const { error, response } = await createVatDetail(vatDetail);
  if(error){
    onHandleFetchError({error});
    return;
  }

  unref(vatDetails).push(response!);
}

onMounted(() => {
  loadVatDetails();
})


return { __sfc: true,regularVatTypes, reducedVatTypes, reducedVatListRef, regularVatListRef, reducedVatListValid, regularVatListValid, vatDetails, emits, onHandleFetchError, loadVatDetails, removeVatDetail, addVatDetail, VatType, VatDetailEdit, editSettingsPolicy, hasAccessRights }
}

})